import { render, staticRenderFns } from "./RelativeAccount.vue?vue&type=template&id=56a36dc1&scoped=true"
import script from "./RelativeAccount.vue?vue&type=script&lang=js"
export * from "./RelativeAccount.vue?vue&type=script&lang=js"
import style0 from "./RelativeAccount.vue?vue&type=style&index=0&id=56a36dc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a36dc1",
  null
  
)

export default component.exports